/**
 * Constants and configuration for BookList component
 * All constants in one place - utility functions are in utils.ts
 */

import type { ViewModeConfig } from '@/types'

// ============================================================================
// VIEW MODE CONSTANTS
// ============================================================================

export const COMPACT_LIST_VIEW = 'compact_list' as const
export const EXTENDED_LIST_VIEW = 'extended_list' as const
export const COMPACT_CARDS_VIEW = 'compact_cards' as const
export const FULL_CARDS_VIEW = 'full_cards' as const

export const VIEW_MODES: ViewModeConfig[] = [
    { id: 'full-cards', icon: '🃏', label: 'bookList.viewModes.fullCards' },
    { id: 'compact-cards', icon: '📇', label: 'bookList.viewModes.compactCards' },
    { id: 'compact-list', icon: '📋', label: 'bookList.viewModes.compactList' },
    { id: 'extended-list', icon: '📊', label: 'bookList.viewModes.extendedList' },
]

// ============================================================================
// PAGINATION CONSTANTS
// ============================================================================

export const PER_PAGE_OPTIONS = [10, 25, 50, 100] as const
export const DEFAULT_PER_PAGE_OPTIONS = [12, 24, 48, 96] as const

// ============================================================================
// FILTER CONSTANTS
// ============================================================================

export { FORMAT_OPTIONS, STATUS_OPTIONS, PROGRESS_OPTIONS } from '@/constants/bookOptions'
